import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    IconButton,
    Tooltip,
    Typography,
    WithStyles
} from "@material-ui/core";
import { styles } from "./Contracts.styles";
import CloseIcon from "@material-ui/icons/Close";
import { BlueButton } from "../../../components/Buttons/BlueButton";
import { IBPOKCheck } from "../../../components/BusinessPartnersTextField/BusinessPartnersTextField";
import {
    BusinessPartnersTextField,
    IBusinessPartner
} from "../../../components/BusinessPartnersTextField/BusinessPartnersTextField";

export interface IImportBusinessPartnersDialogProps extends WithStyles<typeof styles> {
    onConfirm?: (businessPartners: IBusinessPartner[]) => void;
    onClose?: () => void;
}

const ImportBusinessPartnersDialogPure: React.FunctionComponent<IImportBusinessPartnersDialogProps> = (
    props: IImportBusinessPartnersDialogProps
) => {
    const { onConfirm, onClose, classes } = props;

    const [isConfirmationDialogShown, setIsConfirmationDialogShown] = useState<boolean>(false);
    const [isBPsOK, setIsBPsOK] = useState<boolean>(false);
    const [businessPartners, setBusinessPartners] = useState<IBusinessPartner[]>([]);

    const handleClose = () => {
        onClose();
    };

    const handleBPChange = (result: IBPOKCheck) => {
        setIsBPsOK(result?.result);
        setBusinessPartners(result?.businessPartners);
    };

    const handleYesClick = () => {
        setIsConfirmationDialogShown(false);
        onConfirm(businessPartners);
    };

    const handleConfirmClick = () => {
        setIsConfirmationDialogShown(true);
    };

    const isSendEnabled = isBPsOK === true && businessPartners?.length > 0;

    return (
        <>
            <Dialog open fullWidth scroll="paper" onClose={handleClose} maxWidth="md">
                <DialogTitle>
                    <Typography variant="subtitle1">Import business partners</Typography>
                    <IconButton
                        aria-label="close"
                        style={{ position: "absolute", right: "1px", top: "1px" }}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <FormControl className={classes.formControl}>
                        <div className={classes.sectionInput}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant={"body2"} gutterBottom>
                                        Please select a comma-separated values (.csv) or text (.txt) file containing
                                        business partners separated by a new line.
                                    </Typography>
                                    <Typography variant={"body2"} gutterBottom>
                                        Format is following: <i>BP Id (number), BP Name, Country code (two letters).</i>
                                    </Typography>
                                    <Typography variant={"body2"} gutterBottom>
                                        Example: <i>12345, Deutsche Boerse, DE</i>
                                    </Typography>
                                    <Typography variant={"body2"} gutterBottom>
                                        Note: Items with already existing BP Ids will be updated. New entries will be
                                        created for new BP Ids.
                                    </Typography>
                                    <BusinessPartnersTextField onChange={handleBPChange} />
                                </Grid>
                            </Grid>
                        </div>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Tooltip title={!isSendEnabled ? "Please enter at least one business partner" : ""}>
                        <span>
                            <BlueButton onClick={handleConfirmClick} disabled={!isSendEnabled}>
                                Import
                            </BlueButton>
                        </span>
                    </Tooltip>
                    <BlueButton onClick={onClose}>Cancel</BlueButton>
                </DialogActions>
            </Dialog>

            <Dialog open={isConfirmationDialogShown}>
                <DialogTitle id="confirm-reinitialization-and-clean-dialog">
                    <Typography variant="h4" gutterBottom>
                        Do you want to import business partners?
                    </Typography>
                    <Typography variant="caption" paragraph>
                        {}
                    </Typography>
                    <Typography variant="caption">
                        {businessPartners?.length} business partners will be imported.
                    </Typography>
                </DialogTitle>
                <DialogActions>
                    <BlueButton onClick={handleYesClick}>Yes</BlueButton>
                    <BlueButton onClick={() => setIsConfirmationDialogShown(false)}>No</BlueButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export const ImportBusinessPartnersDialog = withStyles(styles)(ImportBusinessPartnersDialogPure);
